import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { H2, Icon, Root, P, FADE_TIMEOUT, ImgContainer, CopyContainer } from '../Base';
import { isEmpty } from '../../../../../../../core/util/empty';

class Overview extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/02_basics.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>The basics</H2>

            <P>
              Your plan works like this: there's usually a monthly fee&mdash;a premium&mdash;you pay{' '}
              to have health insurance so you're covered when you or someone in your family gets{' '}
              sick, injured, or needs to see a doctor.
            </P>

            <P>
              Keep in mind, not everything is covered by your plan. You don't want to get caught in{' '}
              a pickle so if you’re not sure what’s covered, double check.
            </P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Overview;
